<template>
    <ContentOrLoading>
        <div id="confirmacion" v-if="iframe && !loading">
            <iframe 
                class="shadow my-2 bg-white" 
                style="display: block; margin: 0 auto; overflow-y: scroll; overflow-x: hidden;" title="TPV"
                sandbox="allow-top-navigation allow-scripts allow-same-origin allow-forms" 
                :src="iframe" 
                width="325"
                height="523" 
                frameborder="0" 
                scrolling="yes"
                loading="lazy"
            ></iframe>
        </div>
        <FormularioPagoComponent
            :jet_id="jet_id"
            :session_id="session_id"
            :tipo_venta="tipo_venta"
            :es-plazos="esPlazos"
            :importe-carrito="importeCarrito"
            :gastos-gestion-unitarios="gastosGestionUnitarios"
            :num-abonados="numAbonados"
            :store="store"
            :get-vuex-alias="getVuexAlias"
            @payToken="payToken"
            @bizumError="onBizumError"
            v-else-if="!loading"
        />
    </ContentOrLoading>
</template>

<script>
    import ContentOrLoading from '@/components/backend/components/ContentOrLoading';
    import FormularioPagoComponent from '@/components/frontend/compra/FormularioPagoComponent.vue';

    export default {
        props: {
            tipo_venta: { type: String, default: null },
            jet_id: { type: [String, Number], default: null },
            session_id: { type: String, default: null },
            tid: { type: [String, Number], default: null },
            plazos: { type: [String, Number, Array, Boolean], default: null },
            guardarTarjeta: { type: Boolean, default: false },
            esPlazos: { type: Boolean, default: false },
            importeCarrito: { type: [String, Number], default: 0 },
            gastosGestionUnitarios: { type: [String, Number], default: 0 },
            numAbonados: { type: [String, Number], default: 1 },
            store: { type: Object, default: null },
            getVuexAlias: { type: Function, default: null },
            /**
             * Cuando es true desactiva la redirección posterior al callback en
             * el case 'cambio-butaca'. El flujo de cambio de asiento lo usa
             * para quedarse en el paso post-pago (PASO_PAGO_CONFIRMACION).
             * Retro-compatible: default false conserva el comportamiento legacy.
             */
            noRedirigir: { type: Boolean, default: false },
        },
        data() {
            return {
                iframe: '',
                jetToken: null,
                interval: null,
                timeout: null,
                redirectTimeout: null,
                loading: false,
                error: {
                    102: 'Operación no permitida por tipo de tarjeta',
                    105: 'Crédito insuficiente',
                    108: 'Error en el número de tarjeta',
                    109: 'Error en la fecha de caducidad',
                    110: 'Error en los datos',
                    111: 'Bloque CVC2 incorrecto',
                    133: 'Error al procesar el pago, inténtelo de nuevo'
                },
                time_left: null,
            }
        },
        created() {
            if(this.$store.state.timeEnd) {
                this.$store.state.timeEnd.add(5, 'minutes');
            }        
        },
        methods: {
            clearAllIntervals() {
                clearInterval(this.interval);
                clearTimeout(this.timeout);
                clearTimeout(this.redirectTimeout);
                this.redirectTimeout = null;
            },
            clearSessions() {
                if (localStorage.getItem('sga_abono_cart_id')) localStorage.removeItem('sga_abono_cart_id');
                if (localStorage.getItem('sga_eventos_cart_id')) localStorage.removeItem('sga_eventos_cart_id');
            },
            // ponytail: propagate Bizum errors from FormularioPagoComponent up to a
            // toast so the user sees what went wrong instead of nothing happening.
            onBizumError(message) {
                this.$toast.error(message || 'Error al procesar el pago con Bizum', {
                    position: 'bottom-right',
                    duration: 3000,
                    fullWidth: false
                });
            },
            payToken(jetToken) {
                this.loading = true;
                this.jetToken = jetToken;

                if (this.tipo_venta == 'editarInfoPago') {
                    this.procesarConfirmacionTarjeta();
                } else if (this.tipo_venta == 'plazosAbono' || this.tipo_venta == 'plazosBase') {
                    this.procesarPagoPlazosPerfil();
                } else {
                    this.procesarPago();
                }
            },
            procesarPago() {
                const params = {
                    filters: {},
                    session_id: this.session_id,
                    jetToken: this.jetToken,
                    tipo_venta: this.tipo_venta
                }
                this.$store.dispatch(this.config.getVuexAlias('front.procesar-pago-paycomet'), params).then(res => {
                    if (res.data.response.challengeUrl) {
                        this.loading = false;
                        this.iframe = res.data.response.challengeUrl;
                        this.interval = setInterval(() => this.getCompraFinalizada(), 3000);
                    } else if (res.data.response.compraFinalizada) {
                        this.loading = true;
                        this.getCompraFinalizada();
                    }
                }).catch(error => {
                    this.$toast.error((this.error[error.response.data.response.errorCode] || error.response.data.response.errorCodeMsg), { position: 'bottom-right', duration: 2500, fullWidth: false });
                    this.loading = false;
                });
            },
            procesarConfirmacionTarjeta() {
                const params = {
                    filters: {},
                    jetToken: this.jetToken,
                    tid: this.tid
                }
                this.$store.dispatch(this.config.getVuexAlias('front.perfil.procesar-confirmacion-tarjeta'), params).then(res => {
                    if (res.data.response.challengeUrl) {
                        this.iframe = res.data.response.challengeUrl;
                        this.loading = false;
                    } else if (res.data.response.compraFinalizada) {
                        this.$emit('confirmacionTarjeta');
                    }
                }).catch(error => {
                    this.$toast.error('Ha ocurrido un error');
                });
            },
            procesarPagoPlazosPerfil() {
                const params = {
                    filters: {},
                    jetToken: this.jetToken,
                    tid: this.tid,
                    plazos: this.plazos,
                    guardarTarjeta: this.guardarTarjeta,
                    tipo_venta: this.tipo_venta
                }

                this.$store.dispatch(this.config.getVuexAlias('front.perfil.procesar-pago-plazos'), params).then(res => {
                    if (res.data.response.challengeUrl) {
                        this.iframe = res.data.response.challengeUrl;
                        this.loading = false;
                    } else if (res.data.response.compraFinalizada) {
                        this.$emit('confirmacionTarjeta');
                    }
                }).catch(error => {
                    this.$toast.error('Ha ocurrido un error');
                });
            },
            getCompraFinalizada() {
                const params = {
                    filters: {},
                    session_id: this.session_id,
                    tipo_pedido: this.tipo_venta
                }
                this.$store.dispatch(this.config.getVuexAlias('front.get-pedido-procesado-paycomet'), params).then(res => {
                    if (!res.data.error) {
                        this.clearAllIntervals();
                        this.clearSessions();
        
                        switch (this.tipo_venta) {    
                            case 'base':
                                this.$router.push(`/cantera/compra/${this.session_id}/${res.data.n_pedido}`);
                                break;
                            case 'parcelas':
                                this.$router.push(`/compra-parcelas/${this.session_id}/${res.data.n_pedido}`);
                                break;
                            case 'sga' :
                                this.$router.push(`/compra-lfp/${this.session_id}/${res.data.n_pedido}`);
                                break;
                            case 'cambio-nombre' :
                                this.$router.replace(`/perfil/${this.$route.params.tpv_order}?pasoFinal`);
                                break;
                            case 'cambio-butaca' :
                                // Limpiamos el iframe (que seguía mostrando el
                                // 3DS challenge) y emitimos un evento al padre
                                // para que muestre el estado de completado
                                // antes de navegar.
                                this.iframe = '';
                                this.loading = false;
                                this.clearAllIntervals();
                                this.$emit('completado', res.data);
                                // Cuando `noRedirigir` es true (paso de
                                // confirmación post-pago del cambio de asiento),
                                // NO navegamos: el padre mantiene el wizard en
                                // el nuevo paso. Por defecto (false) se conserva
                                // el comportamiento legacy: volvemos al listado
                                // de abonos con `cambio-butaca=true` para que
                                // PerfilAbonosView muestre el toast de éxito.
                                // Pequeño delay para que el padre procese el
                                // emit antes de cambiar de ruta.
                                if (!this.noRedirigir) {
                                    this.redirectTimeout = setTimeout(() => {
                                        this.redirectTimeout = null;
                                        // El componente puede haberse destruido antes
                                        // de los 50ms; evita navegar desde una
                                        // instancia muerta.
                                        if (this._isDestroyed) return;
                                        this.$router.replace('/perfil?tab=abonos&cambio-butaca=true');
                                    }, 50);
                                }
                                break;
                            default:
                                this.$router.push(`/compra/${this.session_id}/${res.data.n_pedido}`);
                                break;
                        }                    
                    } else {
                        if (res.data.message === 'Pedido fallido') {
                            this.$router.push({name: 'compra.error'});
                        }
                    }
                }).catch(e => {});
            },
        },
        components: { FormularioPagoComponent, ContentOrLoading },
        beforeDestroy() {
            this.clearAllIntervals();
        }
    }
</script>